<div class="app-profile app-ic-home ic-home"
  [ngStyle]="{'background-color': settingsData.bg_secondary_color ? settingsData.bg_secondary_color : null,'font-family': settingsData.font_family ? settingsData.font_family : null  }"
  [style.--home-accent]="settingsData.bg_primary_color || null"
  [style.--home-accent-text]="settingsData.font_primary_color || null"
  [style.--home-divider]="settingsData.font_secondary_color || null">
  <div class="relative">
    <div class="overlay-play-btn"></div>
    <!-- <div class="img-txt">
          <div class="profile-icon text-center fs-16" *ngIf="performerInfo?.performer_profile_pic == null">{{displayName}}</div>
          <div class="artist-pic" *ngIf="performerInfo?.performer_profile_pic != null"
            [ngStyle]="{'background-image':' url(' + performerInfo?.performer_profile_pic + ')'}"></div>
          <p class="stream-name pt-15">{{performerInfo?.performer_display_name}}</p>
          <button mat-flat-button class="followBtn">FOLLOW</button>
        </div> -->
    <!-- <video [poster]="performerInfo?.performer_profile_banner" *ngIf="performerInfo?.performer_profile_video" controls
      controlsList="nodownload" id="videoPlayer" class="video">
      <source [src]="performerInfo?.performer_profile_video">
    </video> -->
    <div class="default-img" *ngIf="(org_info?.channel_banner  && !router.url.includes('/channel/'))"
      [ngStyle]="{'background-image':' url(' + org_info?.channel_banner  + ')'}">
    </div>

    <div class="default-img" *ngIf="router.url.includes('/channel/') && settingsData && settingsData.banner_image"
      [ngStyle]="{'background-image':' url(' + settingsData.banner_image + ')'}">
    </div>

    <button *ngIf="!settingsData.is_preview && !router.url.includes('/preview')" mat-button class="subscribe-btn vh-45"
      (click)="goTO()" [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null , 
    'color': settingsData.font_primary_color ? settingsData.font_primary_color : null , 'font-size': settingsData.fs_main_title ? settingsData.fs_main_title : null ,
    'font-family': settingsData.font_family ? settingsData.font_family : null  }">
      <div [ngStyle]="{'font-family': settingsData.font_family ? settingsData.font_family : null}">
        <!-- {{subscribedUserPlans && subscribedUserPlans.length > 0 && subscribedUserPlans[0] && userInfo && userInfo.id ? 'Subscribed' : 'Subscribe'}} -->
        {{isSubscribed && userInfo && userInfo.id ? 'Subscribed' : 'Subscribe'}}
      </div>
    </button>
    <button *ngIf="settingsData.is_preview && router.url.includes('/preview')" mat-button class="subscribe-btn vh-45 disable"
      [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null , 
        'color': settingsData.font_primary_color ? settingsData.font_primary_color : null , 'font-size': settingsData.fs_main_title ? settingsData.fs_main_title : null ,
        'font-family': settingsData.font_family ? settingsData.font_family : null  }">
      <div [ngStyle]="{'font-family': settingsData.font_family ? settingsData.font_family : null}"> subscribe</div>
    </button>


    <!-- <div class="logo-pic-box" [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null , 
    'color': settingsData.font_primary_color ? settingsData.font_primary_color : null , 'font-size': settingsData.fs_main_title ? settingsData.fs_main_title : null ,
    'font-family': settingsData.font_family ? settingsData.font_family : null  }"> -->

    <div class="logo-pic-box">
      <!-- <div class="artist-pic m-0" *ngIf="org_info?.organization_logo"
        [ngStyle]="{'background-image':' url(' + org_info?.organization_logo + ')'}">
      </div>
      <label class="pl-20 mb-0 performer-name text-capitalize" [ngStyle]="{'color': settingsData.font_primary_color ? settingsData.font_primary_color : null , 
      'font-size': settingsData.fs_main_title ? settingsData.fs_main_title : null ,
      'font-family': settingsData.font_family ? settingsData.font_family : null  }">
        {{org_info?.organization_name}}
      </label> -->
      <!-- <div class="m-0 w-image pointer" *ngIf="deviceType == 'browser' && appType !='native'" >
        <img src="assets/logo.svg" class="pointer" [ngClass]="{'slick-disabled':router.url.includes('/preview')}" (click)="redirectTo()">
      </div> -->

    </div>
  </div>
  <!-- ads start -->
  <div class="text-center p-20" *ngIf="showAdCenter">
    <div class="d-inline-block relative">
      <div [innerHTML]="adVideoCenter" alt=' ' title=' ' class="adcenter text-center">
      </div>
      <span class="icon-bg mr-2">
        <a class="text-center" *ngIf="!router.url.includes('/preview')" [href]="selectedAdCenterData" target="_blank"
          class="mr-2 text-white text-decoration-none">Learn more <i class="fa fa-external-link fs-9 ml-1"></i></a>
        <a class="text-center" *ngIf="router.url.includes('/preview')"
          class="mr-2 text-white text-decoration-none slick-disabled">Learn more <i
            class="fa fa-external-link fs-9 ml-1"></i></a>
      </span>
    </div>
  </div>
  <!-- ads end -->
  <!-- Groups list starts here -->
  <div class="gener-types" *ngIf="groups && groups.length > 0">
    <div class="row no-gutters justify-content-center">
      <div class="col-11">
        <div class="row align-items-center mb-10 mt-20">
          <div class="col-6">
            <div class="gener-heading" [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null ,
              'font-size': settingsData.fs_main_title ? settingsData.fs_main_title : null,
              'font-family': settingsData.font_family ? settingsData.font_family : null }">
              {{groupsLabel}}
            </div>
          </div>
        </div>
        <div class="g-tile-row" #groupRow>
          <div class="g-tile pointer" *ngIf="networkTile"
            [ngClass]="{'slick-disabled': router.url.includes('/preview'), 'g-tile--active': !groupName}"
            [style.--tint]="getGroupTint(networkTile)"
            [matTooltip]="networkTile.name?.length > 25 ? networkTile.name : ''"
            (click)="goToNetwork()">
            <ng-container *ngTemplateOutlet="groupTileBody; context: { $implicit: networkTile }"></ng-container>
            <i class="fa fa-check g-tile-check" *ngIf="!groupName"></i>
          </div>
          <div class="g-tile pointer" *ngFor="let group of homeGroups"
            [ngClass]="{'slick-disabled': router.url.includes('/preview'), 'g-tile--active': group.group_slug === groupName}"
            [style.--tint]="getGroupTint(group)"
            [matTooltip]="group.name?.length > 25 ? group.name : ''"
            (click)="goToGroup(group)">
            <ng-container *ngTemplateOutlet="groupTileBody; context: { $implicit: group }"></ng-container>
            <i class="fa fa-check g-tile-check" *ngIf="group.group_slug === groupName"></i>
          </div>
        </div>
        <ng-template #groupTileBody let-group>
          <img *ngIf="group.group_logo" class="g-tile-logo" [src]="group.group_logo" alt="" />
          <span *ngIf="!group.group_logo" class="g-tile-logo g-tile-logo--initial">{{ getGroupInitials(group.name) }}</span>
          <span class="g-tile-name"
            [ngStyle]="{'font-family': settingsData.font_family ? settingsData.font_family : null}">{{group.name}}</span>
          <span class="g-tile-arrow"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span>
        </ng-template>
        <hr *ngIf="upCommingEventList && upCommingEventList.length > 0 && deviceType == 'browser'">
      </div>
    </div>
  </div>
  <div class="row no-gutters justify-content-center"
    *ngIf="upCommingEventList && upCommingEventList.length > 0 && deviceType == 'browser'">
    <div class="col-11 ">
      <div class="gener-heading" [ngClass]="groups && groups.length > 0 ? 'mt-10 mb-10' : 'mt-50 mb-30'" [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null , 
        'font-size': settingsData.fs_main_title ? settingsData.fs_main_title : null ,
        'font-family': settingsData.font_family ? settingsData.font_family : null  }">
        Upcoming events
      </div>
      <div class="upcoming-container" id="event-container" #widgetsContent>
        <span class=" d-none d-md-inline-block">
          <i class="fa fa-play next" (click)='scrollRight()'></i>
        </span>
        <span class=" d-none d-md-inline-block">
          <i class="fa fa-play next previous" (click)='scrollLeft()'></i>
        </span>

        <div class="ev-card pointer" *ngFor="let data of upCommingEventList"
          [ngClass]="{'slick-disabled': router.url.includes('/preview')}"
          [matTooltip]="data?.stream_info?.stream_video_title?.length > 43 ? data?.stream_info?.stream_video_title : ''"
          (click)="goToEvent(data)">
          <ng-container *ngIf="!data.bannerFallback; else evInitial">
            <img class="ev-backdrop" [src]="data.event_home_banner" alt="" aria-hidden="true" />
            <img class="ev-img" [src]="data.event_home_banner" alt="" (error)="data.bannerFallback = true" />
          </ng-container>
          <ng-template #evInitial>
            <span class="ev-initial">{{ getEventInitial(data) }}</span>
          </ng-template>
          <span class="ev-title"
            [ngStyle]="{'font-family': settingsData.font_family ? settingsData.font_family : null}">{{data?.stream_info?.stream_video_title}}</span>
        </div>
      </div>
      <!-- <hr class="mb-0"> -->
    </div>
  </div>
  <!-- Sub channel list starts here -->
  <div class="gener-types" [ngClass]="!performerInfo?.performer_bio && !generList.length ? 'pb-60': 'pb-0' " *ngIf="isNetworkChannel && subChannelsList && subChannelsList.length > 0">
    <div class="row no-gutters justify-content-center">
      <ng-container>
        <div class="col-11">
          <hr *ngIf="subChannelsList && subChannelsList.length > 0 ">
          <div class="row align-items-center mb-10 mt-20">
            <div class="col-6">
              <div class="gener-heading" [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null ,
                'font-size': settingsData.fs_main_title ? settingsData.fs_main_title : null,
                'font-family': settingsData.font_family ? settingsData.font_family : null }"
                *ngIf="subChannelsList && subChannelsList.length > 0 ">
                CHANNELS
              </div>
            </div>
            <!-- <div class="col-6 text-right">
              <span class="see-all" [ngStyle]="{'color': settingsData.font_primary_color ? settingsData.font_primary_color : null ,'font-size': settingsData.fs_sub_title ? settingsData.fs_sub_title : null }"
                *ngIf ="subChannelsList && subChannelsList.length > 5"
                (click)="seeAllChannels()">
                view all
              </span>
            </div> -->
          </div>
          <div class="relative">
            <span class="g-previous flex-btns pointer"
              *ngIf="subChannelsList && subChannelsList.length > 5 && showSubChannelLeftButton"
              (click)="leftScrollChannels()">
              <i class="fa fa-angle-left text-white"> </i>
            </span>
            <span class="g-next flex-btns pointer"
              *ngIf="subChannelsList && subChannelsList.length > 5 && showSubChannelRightButton"
              (click)="rightScrollChannels()">
              <i class="fa fa-angle-right  text-white"> </i>
            </span>
            <div class="g-container ch-row" id="sub-channel-container">
              <div class="ch-card pointer" *ngFor="let subChannel of subChannelsList"
                [ngClass]="{'slick-disabled': router.url.includes('/preview')}"
                [style.background-color]="subChannel.logo ? null : subChannel.cardBackgroundColor"
                [matTooltip]="subChannel?.channel_display_name?.length > 25 ? subChannel?.channel_display_name : ''"
                (click)="goToChannel(subChannel)">
                <ng-container *ngIf="subChannel.logo; else chInitials">
                  <div class="ch-blur" [style.background-image]="'url(' + subChannel.logo + ')'"></div>
                  <img class="ch-logo" [src]="subChannel.logo" alt="" />
                </ng-container>
                <ng-template #chInitials>
                  <span class="ch-initials" [style.color]="getCardTitleColor(subChannel.cardBackgroundColor)">{{ getGroupInitials(subChannel.channel_display_name) }}</span>
                </ng-template>
                <span class="ch-name"
                  [ngStyle]="{'font-family': settingsData.font_family ? settingsData.font_family : null}">{{subChannel.channel_display_name}}</span>
                <span class="ch-go"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <!-- <hr class="mb-0" *ngIf="subChannelsList && subChannelsList.length > 0 "> -->
  <div class="gener-types" [ngClass]="!performerInfo?.performer_bio ? 'pb-30': 'pb-0' " *ngIf="generList.length > 0">
    <div class="row no-gutters justify-content-center">
      <ng-container *ngFor="let data of generList;let i =  index">
        <div class="col-11" *ngIf="data?.data?.length != 0">
          <hr
            *ngIf="i > 0 || subChannelsList && subChannelsList.length > 0 || upCommingEventList && upCommingEventList.length > 0 || groups && groups.length > 0">
          <div class="row align-items-center mb-10 mt-20">
            <div class="col-6">
              <div class="gener-heading" [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null ,
                'font-size': settingsData.fs_main_title ? settingsData.fs_main_title : null,
                'font-family': settingsData.font_family ? settingsData.font_family : null }">
                {{data.name}}
              </div>
            </div>
            <div class="col-6 text-right">
              <span class="see-all" *ngIf="data.seeAll"
                [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null ,'font-size': settingsData.fs_sub_title ? 'calc(' + settingsData.fs_sub_title + ' * 0.8)' : null }"
                (click)="goToGener(data)">view all</span>
            </div>
          </div>

          <div class="relative">
            <span class="g-previous flex-btns pointer" *ngIf="data.lefthide" (click)="leftScroll(i,data)">
              <i class="fa fa-angle-left text-white"> </i>
            </span>
            <span class="g-next flex-btns pointer" *ngIf="data.righthide" (click)="rightScroll(i,data)">
              <i class="fa fa-angle-right  text-white"> </i>
            </span>
            <div class="g-container gn-row" [id]="'gener'+i">
              <ng-container *ngFor="let xyz of data.data">
                <div class="gn-card pointer" *ngIf="xyz.name != 'seeall'"
                  [matTooltip]="xyz?.album?.length > 25 ? xyz?.album : ''"
                  (click)="goToAlbum(xyz)">
                  <div *ngIf="hasOwnThumbnail(xyz)" class="gn-img" [style.background-image]="'url(' + xyz.video_thumbnail_image + ')'"></div>
                  <div *ngIf="!hasOwnThumbnail(xyz)" class="gn-fallback">
                    <i class="fa" [ngClass]="getMediaType(xyz, data) === 'audio' ? 'fa-music' : 'fa-video-camera'"></i>
                  </div>
                  <span class="gn-type"><i class="fa" [ngClass]="getMediaType(xyz, data) === 'audio' ? 'fa-music' : 'fa-video-camera'"></i></span>
                  <span class="gn-play"><i class="fa fa-play"></i></span>
                  <span class="gn-title"
                    [ngStyle]="{'font-family': settingsData.font_family ? settingsData.font_family : null}">{{xyz.album}}</span>
                </div>
                <div class="gn-card gn-seeall bg-dark relative seeall-image" *ngIf="xyz.name == 'seeall' && data.seeAll" (click)="goToGener(data)">
                  <i class="fa fa-angle-right see-Arrow"></i>
                  <div class="see-all-hover text-center">
                    View All
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <!-- No content display -->
  <div
    *ngIf="!isNetworkChannel && generList[0] && generList[0].data.length == 0 && upCommingEventList.length == 0 && this.pastEvents.length == 0"
    class="no-data">
    No content to display
  </div>

  <div class="p-para bg-secondary-level br-4  pt-20 mt-20" [ngClass]="(deviceType == 'browser') ? 'pb-0': 'pb-80' "
    *ngIf="(performerInfo?.performer_bio || activeGroupData?.group_description) || (router.url.includes('/channel/') && subChannelInfo?.bio )"
    [ngStyle]="{'background-color': settingsData.bg_tertiary_color ? settingsData.bg_tertiary_color : null }">
    <div class="row no-gutters justify-content-center">
      <div class="col-11">
        <h5 class="ic-heading">
          <div [ngStyle]="{'color': settingsData.font_tertiary_color ? settingsData.font_tertiary_color : null ,
          'font-size': settingsData.fs_main_title ? settingsData.fs_main_title : null ,
          'font-family': settingsData.font_family ? settingsData.font_family : null }">About</div>
        </h5>
        <div class="lorem-ipsum-is-simpl" [ngStyle]="{'color': settingsData.font_tertiary_color ? settingsData.font_tertiary_color : null,'font-size': settingsData.fs_sentence ? settingsData.fs_sentence : null ,
          'font-family': settingsData.font_family ? settingsData.font_family : null,'font-size': settingsData.fs_sentence ? settingsData.fs_sentence : null}">
          <p [innerHTML]="groupName ? activeGroupData?.group_description : performerInfo?.performer_bio" *ngIf="(router.url.includes('/channel/') && !subChannelInfo?.bio) || !router.url.includes('/channel/')"></p>
          <ng-container *ngIf="router.url.includes('/channel/') && subChannelInfo?.bio">
            <p [innerHTML]="subChannelInfo?.bio"></p>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="pt-4 pb-4 fw-500" [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null, 'font-size': settingsData.fs_main_title ? settingsData.fs_main_title : null ,'color': settingsData.font_primary_color ? settingsData.font_primary_color : null ,
  'font-family': settingsData.font_family ? settingsData.font_family : null  }">
    <div class="row no-gutters justify-content-center align-items-center">
      <div class="col-6">
        Download the App Now!
      </div>
      <div class="col-5 text-right">
        <ng-container class="d-inline">
          <a href="" target="_blank"><img src="assets/website/homepage/googleplay.png" width="130px"></a>
          <a href="" target="_blank"><img src="assets/website/homepage/appstore.png" width="130px" class="ml-2"></a>
        </ng-container>
      </div>
    </div>

  </div> -->
</div>
<button matTooltip="Subscribe" matTooltipPosition='left' [ngClass]="{'show-scroll': showScroll}"
  *ngIf="!settingsData.is_preview && !router.url.includes('/preview') && !isSubscribed" mat-button
  class="subscribe-btns scroll-to-top" (click)="goTOsticky()" [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null , 
'color': settingsData.font_primary_color ? settingsData.font_primary_color : null , 'font-size': settingsData.fs_sentence ? settingsData.fs_sentence : null ,
'font-family': settingsData.font_family ? settingsData.font_family : null  }">
  <div [ngStyle]="{'font-family': settingsData.font_family ? settingsData.font_family : null}">
    <!-- {{subscribedUserPlans && subscribedUserPlans.length > 0 && subscribedUserPlans[0] && userInfo && userInfo.id ? 'Subscribed' : 'Subscribe'}} -->
    <!-- {{isSubscribed && userInfo && userInfo.id ? 'Subscribed' : 'Subscribe'}} -->
    <i class="fa fa-hand-o-up player-icon play-icon pl-0" aria-hidden="true"></i>

  </div>
</button>